var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlvd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1537 10.8058C17.1754 10.783 17.1968 10.7599 17.2177 10.7365C18.4387 9.37673 18.7478 7.42324 18.0065 5.75088C17.2651 4.07854 15.6123 3.00067 13.7882 3H3L3.84639 4.5324L7.27589 10.7427H4.57382V20H16.3842C18.7833 20.001 20.7828 18.1568 20.9836 15.7579C21.1844 13.359 19.5194 11.2061 17.1537 10.8056V10.8058ZM13.7869 4.53213C15.4161 4.53297 16.765 5.80242 16.8702 7.43375C16.9754 9.06509 15.8008 10.4983 14.1853 10.7099L10.7724 4.53213H13.7869ZM5.55498 4.53213H9.06486L12.4914 10.7365H10.356L10.3606 10.7413H8.98528L5.55498 4.53213ZM6.09566 18.473V12.2684H8.12014L11.5478 18.473H6.09566ZM18.1619 17.9084C17.6407 18.2745 17.0203 18.4715 16.3842 18.473H13.2564L9.82873 12.2684H16.3842C17.7325 12.2681 18.9255 13.1449 19.332 14.4349C19.7385 15.7249 19.2647 17.1305 18.1613 17.9081L18.1619 17.9084Z",
    fill: "#35383D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlvd);
export default __webpack_public_path__ + "static/media/Blvd.21d7d7a37aa69033a51241b7ebd63ca1.svg";
export { ForwardRef as ReactComponent };